<template>
  <div v-if="!admin" class="mt-1">
    <h3 class="grey darken-2 white--text pa-2">PWG Members Admin Panel</h3>
    <v-alert v-if="success" :value="true" color="green darken-5 white--text">
      <h3>
        Success: {{result}}
        <v-btn flat class="green darken-5" @click="error = false, success = false">
          <v-icon medium class="pl-2 white--text">close</v-icon>
        </v-btn>
      </h3>
    </v-alert>
    <v-alert v-if="error" :value="true" color="red darken-4 white--text">
      <h3>Error: {{result}}</h3>
    </v-alert>
    <v-divider class="teal lighten-5"></v-divider>
    <v-layout row justify-center>
      <v-dialog id="dialog" v-model="dial" width="150">
        <v-progress-circular :size="100" width="8" color="purple" indeterminate></v-progress-circular>
      </v-dialog>
    </v-layout>
    <v-card flat v-for="(member, i) in members" :key="member.id">
      <v-layout row wrap>
        <v-flex xs12 md5>
          <div class="pa-1">
            <h5 class="pa-2">{{i+1}}. {{member.name}} ({{member.contactemail}})</h5>
          </div>
        </v-flex>
        <v-flex xs12 md2>
          <v-tooltip top>
            <v-btn medium flat slot="activator" @click="setActions(member.contactemail)">
              <v-icon medium color="purple">lock_open</v-icon>
              <span>Reset Password</span>
            </v-btn>
            <span text--white>Require user to reset their Password {{member.contactemail}}</span>
          </v-tooltip>
          <v-dialog v-model="dialog" width="500">
            <v-card>
              <v-card-actions>
                <v-card-text>Do you want to reset the password for {{actionEmail}} ?</v-card-text>
                <v-btn color="primary" @click="resetPassword()">Yes, Reset</v-btn>
                <v-btn color="grey" @click="dialog=false">cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>

        <div class="text-xs-center"></div>

        <v-flex xs12 md2>
          <v-tooltip top>
            <v-btn
              medium
              v-if="member.userlevel == 'basic'"
              @click="setAdmin(member.contactemail)"
              flat
              slot="activator"
            >
              <v-icon medium color="indigo">add_circle</v-icon>
              <span>Make Admin</span>
            </v-btn>
            <span text--white>Make {{member.name}} an Administrator</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              medium
              v-if="member.userlevel == 'admin'"
              @click="setAdmin(member.contactemail)"
              flat
              slot="activator"
            >
              <v-icon medium color="red">remove_circle</v-icon>
              <span>Revoke Admin</span>
            </v-btn>
            <span text--white>Revoke Admin Rights for {{member.contactemail}}</span>
          </v-tooltip>
          <v-dialog v-model="dialog2" width="500">
            <v-card>
              <v-card-actions>
                <v-card-text>Are you sure you want change admin rights for {{actionEmail}} ?</v-card-text>
                <v-btn
                  v-if="member.userlevel == 'admin'"
                  color="primary"
                  @click="removeAdmin()"
                >Yes, I am sure</v-btn>
                <v-btn
                  v-if="member.userlevel !== 'admin'"
                  color="primary"
                  @click="adminFunctions()"
                >Yes, I am sure</v-btn>
                <v-btn color="grey" @click="dialog2=false">cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
        <v-flex xs12 md2>
          <v-tooltip top>
            <v-btn
              medium
              v-if="!blocked"
              disabled
              flat
              slot="activator"
              @click="disableAccount(member.id,'block')"
            >
              <v-icon large color="indigo">toggle_off</v-icon>
              <span>Disable Account</span>
            </v-btn>
            <span text--white>You have no permission to disable {{member.name}}</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              medium
              v-if="blocked"
              disabled
              flat
              slot="activator"
              @click="disableAccount(member.id,'activate')"
            >
              <v-icon large color="grey">toggle_on</v-icon>
              <span>Activate Account</span>
            </v-btn>
            <span text--white>Activite {{member.name}}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
      <v-divider class="grey"></v-divider>
    </v-card>
  </div>
</template>
<script>
import { db, auth, functions } from "@/fb";
const addAdminRole = functions.httpsCallable("addAdminRole");
const removeAdminRole = functions.httpsCallable("removeAdminRole");

export default {
  data() {
    return {
      dial: false,
      email: "",
      admin: false,
      info: "",
      members: [],
      disabled: "",
      blocked: false,
      success: false,
      error: false,
      result: "",
      loading: false,
      dialog: false,
      dialog2: false,
      actionEmail: ""
    };
  },
  methods: {
    setActions(mail) {
      this.dialog = true;
      this.dialog2 = false;
      this.actionEmail = mail;
    },
    setAdmin(mail2) {
      this.dialog2 = true;
      this.dialog = false;
      this.actionEmail = mail2;
      if (this.admin == false) {
        this.adminFunctions;
      }
    },
    disableAccount(userid, status) {
      if (status == "activate") {
        this.blocked = true;
      }
      if (status == "block") {
        this.blocked = true;
      }
      auth()
        .updateUser(userid, {
          disabled: true
        })
        .then(userRecord => {
          // See the UserRecord reference doc for the contents of userRecord.
          console.log("Successfully updated user", userRecord.toJSON());
        })
        .catch(error => {
          console.log("Error updating user:", error);
        });
      /*  admin.auth().getUserByEmail(email)
        .then(function(userRecord) {
          // See the UserRecord reference doc for the contents of userRecord.
          console.log('Successfully fetched user data:', userRecord.toJSON());
        })
        .catch(function(error) {
             console.log('Error fetching user data:', error);
        }); */
    },
    resetPassword() {
      this.dialog = false;
      this.dial = true;
      var actionCodeSettings = {
        url: "https://pwg-kenya.web.app",
        handleCodeInApp: false
      };
      auth
        .sendPasswordResetEmail(this.actionEmail, actionCodeSettings)
        .then(() => {
          this.success = true;
          this.error = false;
          this.result =
            "An email with password reset instructions was sent to " +
            this.actionEmail;
          this.dial = false;
        })
        .catch(error => {
          this.success = false;
          this.error = true;
          this.result = "Action failed, please try again" + error;
        });
    },
    adminFunctions() {
      this.dial = true;
      this.dialog = false;
      this.dialog2 = false;
      addAdminRole({ email: this.actionEmail })
        .then(result => {
          this.info = result;
          this.error = false;
          this.loading = false;
          this.success = true;
          this.result =
            "User with the email " +
            this.actionEmail +
            " has been made an Admin";
          //MAKE CHANGES
          var mid = 0;
          while (mid < this.members.length) {
            if (this.actionEmail == this.members[mid].contactemail) {
              this.members[mid].userlevel = "admin";
              db.collection("members")
                .doc(this.members[mid].id)
                .update({
                  userlevel: "admin"
                })
                .then(() => {
                  this.result =
                    "User with the email " +
                    this.actionEmail +
                    " has been made an Admin";
                  this.dialog = false;
                  this.dialog2 = false;
                  this.dial = false;
                })
                .catch(error => {
                  console.log("Error updating" + error);
                });
            }
            parseInt(mid++);
          }
        })
        .catch(error => {
          this.error = true;
          this.loading = false;
          this.success = false;
          var errorCode = error.code;
          var errorMessage = error.message;
          this.result = errorMessage + " " + errorCode;
        });
    },
    removeAdmin() {
      this.dial = true;
      this.dialog = false;
      this.dialog2 = false;
      removeAdminRole({ email: this.actionEmail })
        .then(result => {
          this.info = result;
          this.error = false;
          this.loading = false;
          this.success = true;
          this.result =
            "User with the " +
            this.actionEmail +
            " has been removed from admins";
          this.dialog = false;
          this.dialog2 = false;
          //MAKE CHANGES
          var mid = 0;
          while (mid < this.members.length) {
            if (this.actionEmail == this.members[mid].contactemail) {
              this.members[mid].userlevel = "basic";
              db.collection("members")
                .doc(this.members[mid].id)
                .update({
                  userlevel: "basic"
                })
                .then(() => {
                  console.log("Database Updated");
                  this.dialog = false;
                  this.dialog2 = false;
                  this.dial = false;
                })
                .catch(error => {
                  console.log("Error updating" + error);
                });
            }
            parseInt(mid++);
          }
        })
        .catch(error => {
          this.error = true;
          this.loading = false;
          this.success = false;
          var errorCode = error.code;
          var errorMessage = error.message;
          this.result = errorMessage + " " + errorCode;
        });
    }
  },
  created() {
    if (auth.currentUser == null) {
      this.$router.push({ name: "home" });
    }
    db.collection("members").onSnapshot(res => {
      const changes = res.docChanges();
      var mid = 0;
      changes.forEach(change => {
        if (change.type === "added") {
          this.members.push({
            ...change.doc.data(),
            id: change.doc.id
          });
          mid++;
        }
      });
    });
  }
};
</script>
<style scoped>
html {
  overflow-y: auto;
}
#dialog {
  overflow-y: auto;
}
</style>
